<template>
  <section class="mt-2 container mx-auto p-2 sm:px-4 lg:p-4 bg-white rounded-lg">
    <div class="w-full">
        <form @submit.prevent="updateConfigDataDetails">
          <div class="form-row flex py-2">
            <label class="w-1/4" for="type">Type:</label>
            <select
              class="w-1/3 h-10 border-borderColor"
              id="type"
              v-model="configDetails.product_type"
              @change="removeErrorHandler('product_type')"
            >
              <option
                v-for="(listItem) in adminProductTypeData"
                :value="listItem.name"
              >{{listItem.name}}
              </option>
            </select>
            <div class="flex flex-col ml-2">
              <small
                class="text-red-500"
                v-for="(itm, prIndex) in formErrors.product_type"
                :key="prIndex"
              >
                {{ itm }}
              </small>
            </div>
          </div>

          <div class="form-row flex py-2">
            <label class="w-1/4">Title:</label>
            <input class="w-1/3 border-borderColor" type="text"
              v-model="configDetails.banner_title"
              @input="removeErrorHandler('banner_title')"
            />
            <div class="flex flex-col ml-2">
              <small
                class="text-red-500"
                v-for="(itm, prIndex) in formErrors.banner_title"
                :key="prIndex"
              >
                {{ itm }}
              </small>
            </div>
          </div>

          <div class="form-row flex py-2">
            <label class="w-1/4">Redirect url:</label>
            <input class="w-1/3 border-borderColor" type="text"
              v-model="configDetails.redirect_url"
              @input="removeErrorHandler('redirect_url')"
            />
            <div class="flex-col ml-2">
              <small
                class="text-red-500"
                v-for="(itm, prIndex) in formErrors.redirect_url"
                :key="prIndex"
              >
                {{ itm }}
              </small>
            </div>
          </div>

          <div class="form-row flex py-2">
            <label class="w-1/4">Position:</label>
            <input class="w-1/3 border-borderColor" type="number"
              v-model="configDetails.position"
              @input="removeErrorHandler('position')"
            />
            <div class="flex flex-col ml-2">
              <small
                class="text-red-500"
                v-for="(itm, prIndex) in formErrors.position"
                :key="prIndex"
              >
                {{ itm }}
              </small>
            </div>
          </div>

          <div class="form-row flex py-2">
            <label class="w-1/4">Description:</label>
            <textarea class="w-1/3 h-32 border-borderColor"
              v-model="configDetails.banner_description"
              @input="removeErrorHandler('banner_description')"
            ></textarea>
            <div class="flex flex-col ml-2">
              <small
                class="text-red-500"
                v-for="(itm, prIndex) in formErrors.banner_description"
                :key="prIndex"
              >
                {{ itm }}
              </small>
            </div>
          </div>

          <div class="form-row flex py-2 items-end">
            <label class="w-1/4">Upload Mobile Image:</label>
            <div class="flex flex-row items-end" v-if="mobileImagePreview">
              <img :src="mobileImagePreview" class="max-w-10" alt="Image Preview">
              <button
                class="bg-black h-10 px-2 ml-3 text-white"
                @click="mobileImageChangeHandler"
              >Change Image</button>
            </div>
            <input v-else class="w-1/3 h-10" type="file" @change="handleMobileImageUpload" />
            <div class="flex flex-col ml-2">
              <small
                class="text-red-500"
                v-for="(itm, prIndex) in formErrors.banner_mobile_image"
                :key="prIndex"
              >
                {{ itm }}
              </small>
            </div>
          </div>

          <div class="form-row flex py-2 items-end">
            <label class="w-1/4">Upload Desktop Image:</label>
            <div class="flex flex-row items-end" v-if="imagePreview">
              <img :src="imagePreview" class="max-w-10" alt="Image Preview">
              <button
                @click="desktopImageChangeHandler"
                class="bg-black h-10 px-2 ml-3 text-white"
              >Change Image</button>
            </div>
            <input v-else class="w-1/3 h-10" type="file" @change="handleDesktopImageUpload" />
            <div class="flex flex-col ml-2">
              <small
                class="text-red-500"
                v-for="(itm, prIndex) in formErrors.banner_image"
                :key="prIndex"
              >
                {{ itm }}
              </small>
            </div>
          </div>

          <div class="form-row flex py-2">
            <label class="w-1/4">Status:</label>
            <input type="checkbox" v-model="configDetails.status" />
          </div>

          <div class="form-row flex py-2">
            <label class="w-1/4">Timer Applicable:</label>
            <input type="checkbox" v-model="configDetails.is_timer_applicable" />
          </div>

          <div class="form-row flex py-2" v-if="configDetails.is_timer_applicable">
            <label class="w-1/4">Timer Start Date:</label>
            <!-- <VueDatePicker class="w-1/3" v-model="timerStartDateTime"></VueDatePicker> -->
            <!-- Testing for @livelybone/vue-datepicker -->
            <!-- <component
              :is="currentComponent"
              class="w-1/3 h-10"
              timeType="minute"
              :value="configDetails.timer_start_time"
              placeholder="Start date time"
              :timeStr="timeStr"
              :dayStr="dayStr"
              btnStr="Select"
              @input="logStartTime" 
            ></component> -->
            <div class="w-1/3">
              <component
                :is="currentComponent"
                class="h-10 px-3 text-base placeholder-gray-600 focus:outline-none border-1 border-borderColor"
                v-model="configDetails.timer_start_time"
                format="MM/DD/YYYY"
                id="endDate"
                no-header 
              ></component>
            </div>
          </div>

          <div class="form-row flex py-2" v-if="configDetails.is_timer_applicable">
            <label class="w-1/4">Timer End Date:</label>
            <!-- <VueDatePicker class="w-1/3" v-model="timerEndDateTime"></VueDatePicker> -->
            <!-- <component
              :is="currentComponent"
              timeType="minute"
              class="w-1/3 h-10"
              :value="configDetails.timer_end_time"
              placeholder="End date time"
              :timeStr="timeStr"
              :dayStr="dayStr"
              btnStr="Select"
              @input="logEndTime" 
            ></component> -->
            <div class="w-1/3">
              <component
                :is="currentComponent"
                class="h-10 px-3 text-base placeholder-gray-600 focus:outline-none border-1 border-borderColor"
                v-model="configDetails.timer_end_time"
                format="MM/DD/YYYY"
                id="endDate"
                no-header 
              ></component>
            </div>
          </div>
          <div class="form-row flex py-2 mt-3">
            <button
              @click.prevent="toggleConfigDetailsDisplay"
              class="h-10 px-5 transition-colors duration-150 ring-1 text-green-light rounded-md focus:outline-none bg-white hover:text-white hover:bg-green-light ring-green-light"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="h-10 px-5 ml-3 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-800"
            >
              Save & Exit
            </button>
          </div>
    </form>

    </div>
  </section>
</template>
<script>
// import '@livelybone/vue-datepicker/lib/css/index.css';
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import { mapGetters} from "vuex";
  export default {
    name: 'AdminConfigDetails',
    props: [
      'toggleConfigDetailsDisplay',
      'getAdminConfigFromStore',
      'operation',
      'dataDetails'
    ],
    data () {
      return {
        timeStr: ['Hour', 'Min', 'sec'],
        dayStr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        configDetails: {
          product_type: '',
          banner_title: '',
          redirect_url: '',
          position: '',
          banner_description: '',
          banner_image: '',
          banner_url: '',
          banner_mobile_image: '',
          banner_mobile_url: '',
          status: 1,
          is_timer_applicable: 0,
          timer_start_time: '',
          timer_end_time: '',
          nav_configuration_id: this.dataDetails.activeConfig.configId,
          nav_sub_config_id: this.dataDetails.activeSubConfig.subConfigId,
          nav_sub_config_name: this.dataDetails.activeSubConfig.subConfigName,
          id: this.dataDetails.id || ''
        },
        formErrors: {},
        imagePreview: null,
        mobileImagePreview: null,
        currentComponent: null
      }
    },
    computed: {
      ...mapGetters(['adminProductTypeData'])
    },
    methods: {
      handleMobileImageUpload(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (files && files.length) {
          let uploadedimage = files[0];
          this.configDetails['banner_mobile_image'] = uploadedimage;
          this.getBase64(uploadedimage).then((data) => {
            this.mobileImagePreview = data;
            this.removeErrorHandler('banner_mobile_image')
          });
        }
      },
      handleDesktopImageUpload(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (files && files.length) {
          let uploadedimage = files[0];
          this.configDetails['banner_image'] = uploadedimage;
          this.getBase64(uploadedimage).then((data) => {
            this.imagePreview = data;
            this.removeErrorHandler('banner_image')
          });
        }
      },
      logStartTime (val) {
        this.configDetails['timer_start_time'] = val
      },
      logEndTime (val) {
        this.configDetails['timer_end_time'] = val
      },
      async getConfigDataDetailsHandler () {
        await this.$store.dispatch('getConfigDataDetails', this.dataDetails).then((res) => {
          this.configDetails = {
            ...res,
            timer_start_time: res.timer_start_time,
            timer_end_time: res.timer_end_time
          }
          this.mobileImagePreview = res && res.banner_mobile_url
          this.imagePreview = res && res.banner_url
        })
      },
      async updateConfigDataDetails () {
        let formData = new FormData();
        for (let key in this.configDetails) {
          if (this.configDetails.hasOwnProperty(key)) {
            if(key === 'status' || key === 'is_timer_applicable') {
              formData.append(key, Number(this.configDetails[key]));
            } else {
              formData.append(key, this.configDetails[key]);
            }
          }
        }
        const dispatchOperation = this.operation === 'edit' ? 'updateConfigDataDetails' : 'addConfigDataDetails'
        this.$store.dispatch(dispatchOperation, formData).then(() => {
          this.toggleConfigDetailsDisplay()
          this.getAdminConfigFromStore()
        }).catch((err) => {
          this.formErrors = {...err.errors}
        })
      },
      removeErrorHandler (keyName) {
        this.formErrors[keyName] && this.$delete(this.formErrors, keyName)
      },
      desktopImageChangeHandler () {
        this.imagePreview = ''
        this.configDetails['banner_image'] = null
        this.configDetails['banner_url'] = null
      },
      mobileImageChangeHandler () {
        this.mobileImagePreview = ''
        this.configDetails['banner_mobile_image'] = null
        this.configDetails['banner_mobile_url'] = null
      }
    },
    created () {
      this.adminProductTypeData && this.adminProductTypeData.length ? '' : this.$store.dispatch('getProductTypeList')
      this.operation && this.operation === 'edit' ? this.getConfigDataDetailsHandler() : ''
    },
    watch: {
      'configDetails.is_timer_applicable': {
        handler () {
          if (this.configDetails['is_timer_applicable']) {
            import('@mathieustan/vue-datepicker').then(({ VueDatePicker }) => {
              this.currentComponent = VueDatePicker
               // plugin tested for future usage
               // import('@livelybone/vue-datepicker').then(({ DatetimePicker }) => {
               //   this.currentComponent = DatetimePicker
               // })
            })
            if (!this.configDetails['timer_start_time'] && !this.configDetails['timer_end_time']) {
              import('moment-timezone').then((module) => {
                const moment = module.default || module;
                this.configDetails['timer_start_time'] = moment().format('YYYY-MM-DD')
                this.configDetails['timer_end_time'] = moment().format('YYYY-MM-DD')
              });
            }
          }
        },
        deep: true
      }
    }
  }
</script>